import { BOT_META, BOT_HELP, NOT_ENOUGH_META, SMALL_META, BotMeter } from "@/components/BotCheck";
import { BOT as LIVE_BOT } from "@/components/LiveIntelTable";

const chip = (c) => ({ color: c, borderColor: `${c}66`, background: `${c}14` });

function Part({ title, label, color, text, testid }) {
  return (
    <div className="p-5 min-w-0" data-testid={testid}>
      <div className="flex items-start justify-between gap-3">
        <span className="mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{title}</span>
        <span data-testid={`${testid}-chip`} className="mono text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded-md border whitespace-nowrap" style={chip(color)}>{label}</span>
      </div>
      <p className="text-sm text-zinc-300 leading-relaxed mt-4" data-testid={`${testid}-text`}>{text}</p>
    </div>
  );
}

function Overall({ verdict }) {
  const m = BOT_META[verdict];
  const c = m ? m.color : "#71717A";
  return (
    <div className="p-5 min-w-0" data-testid="lp-bot-overall" data-verdict={verdict || "not_enough"} style={{ background: `${c}0d` }}>
      <span className="mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Overall bot risk</span>
      <div className="display text-3xl font-semibold mt-2" style={{ color: c }} data-testid="lp-bot-overall-word">{m ? m.word : "Not enough data yet"}</div>
      <div className="mt-3"><BotMeter verdict={verdict} testid="lp-bot-overall-meter" /></div>
    </div>
  );
}

// sub: subscriber Bot Check (undefined = switched off for this viewer). live: live verdict key (undefined = off).
export function LiveBotStrip({ sub, live, overall }) {
  const showSub = sub !== undefined;
  const showLive = live !== undefined;
  if (!showSub && !showLive) return null;
  const parts = [];
  if (showSub && showLive) parts.push(<Overall key="o" verdict={overall} />);
  if (showSub) {
    const m = sub && BOT_META[sub.verdict];
    const small = sub?.verdict === "small";
    const mm = m || (small ? SMALL_META : NOT_ENOUGH_META);
    parts.push(<Part key="s" testid="lp-bot-sub" title="Subscriber Bot Check" label={mm.chip.replace(" BOT RISK", " RISK").replace("NO BOT SIGN", "NO SIGN")}
      color={mm.color} text={BOT_HELP[m ? sub.verdict : small ? "small" : "not_checked"]} />);
  }
  if (showLive) {
    const b = LIVE_BOT[live] || LIVE_BOT.not_enough;
    const label = ["high", "medium", "low"].includes(live) ? `${b.label} risk` : b.label;
    parts.push(<Part key="l" testid="lp-bot-live" title="Live bot check" label={label} color={b.color} text={b.hint} />);
  }
  const cols = parts.length === 3 ? "md:grid-cols-[1fr_1.25fr_1.25fr]" : parts.length === 2 ? "md:grid-cols-2" : "";
  return (
    <section data-testid="lp-bot-strip" className={`border hairline rounded-md overflow-hidden grid grid-cols-1 ${cols} divide-y md:divide-y-0 md:divide-x divide-white/5`} style={{ background: "var(--surface)" }}>
      {parts}
    </section>
  );
}
